import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { DuplicateOrderList } from 'src/app/module/order/interface/order.interface';
import { API_ACTION, API_SCOPE, ApiAction, ApiScope } from 'src/app/shared/interceptor/interceptor.token';
import { CommonApiResponse } from 'src/app/shared/interface/common.interface';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { environment as ENV } from 'src/environments/environment';
import { InitiateOrderApiResponse, NewOrder } from '../interface/new-order.interface';

@Injectable({
  providedIn: 'root',
})
export class NewOrderApi {
  constructor(
    private _http: HttpClient,
    private snackBarService: SnackBarService
  ) {}

  searchProperty(params: any): Observable<any> {
    const httpParams: any = {
      api: '/mls/val/v1/SearchProperty',
      authType: 'app_static',
      apiType: 'data',
      ...params,
    };
    return this._http.get<CommonApiResponse<any>>(`${ENV.backendBaseUrl}/api/proxy/get`, {
      params: httpParams,
      context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.ORDER),
    });
  }

  searchPropertyByMLS(params: any): Observable<any> {
    const httpParams: any = {
      api: '/mls/val/v1/GetListingDetails',
      authType: 'dynamic',
      apiType: 'data',
      includeimages: true,
      includepubrec: true,
      ...params,
    };
    return this._http.get<CommonApiResponse<any>>(`${ENV.backendBaseUrl}/api/proxy/get`, {
      params: httpParams,
      context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.ORDER),
    });
  }

  searchDuplicateOrders(params: any): Observable<DuplicateOrderList[]> {
    const httpParams: any = {
      ...params,
    };

    return this._http
      .get<
        CommonApiResponse<any>
      >(`${ENV.backendBaseUrl}/api/order/getDuplicateOrders`, { params: httpParams, context: new HttpContext().set(API_ACTION, ApiAction.READ).set(API_SCOPE, ApiScope.ORDER) })
      .pipe(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        map((res) => res.data.orderList as DuplicateOrderList[]),
        catchError((error: HttpErrorResponse) => {
          this.snackBarService.open('error', (error?.error?.message as string) || 'Failed to search duplicate orders');
          return throwError(() => error);
        })
      );
  }

  /** No ORDER scope: this creates a new order, so a read-only active order must not block it. */
  createOrder(params: NewOrder): Observable<InitiateOrderApiResponse> {
    const httpParams: any = {
      ...params,
    };
    return this._http
      .post<CommonApiResponse<InitiateOrderApiResponse>>(`${ENV.backendBaseUrl}/api/initiateOrder`, httpParams, {
        context: new HttpContext().set(API_ACTION, ApiAction.WRITE),
      })
      .pipe(map((res) => res.data));
  }
}
